
export const getScale = function(sourceImg, fabricJS) {
    let dw = fabricJS.width / sourceImg.width;
    let dh = fabricJS.height / sourceImg.height;
    let scale = (dw < dh) ? dw : dh;
    return scale
}

export const getNormalizeScale = function(sourceImg, fabricJS) {
    // let normalWidth = 1920;
    // let normalHeight = 1080;
    let normalWidth = 3840;
    let normalHeight = 2160;
    let dw = fabricJS.width / sourceImg.width;
    let dh = fabricJS.height / sourceImg.height;
    let scale = (dw < dh) ? normalWidth/sourceImg.width : normalHeight/sourceImg.height;
    return scale
}

export const getImageFromURL = function(url, callback, imgOptions) {
    fabric.util.loadImage(url, function(img,errorFlag) {
        if (errorFlag)
            callback && callback(null, errorFlag);
        else
            callback && callback(new fabric.Image(img, imgOptions));
    }, null, imgOptions && imgOptions.crossOrigin);
};
